<template>
  <div class="modalUser">
    <b-modal id="modalErrorUploadImage" ref="modalErrorUploadImage" modal-class="modal-no-border modal-rename modal-radius" centered no-close-on-backdrop>
      <template v-slot:modal-header="{ close }">
        <!-- Emulate built in modal header close button action -->
        <div class="title-modal text-center w-100">
          <div class="btn-closeModal" @click="hidePopupImage">
            <svg height="329pt" viewBox="0 0 329.26933 329" width="329pt" xmlns="http://www.w3.org/2000/svg"><path d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
          </div>
        </div>
      </template>
      <div class="modalUser--main files">
        <h2 class="title text-center">通知</h2>
        <p class="sub-title text-center">{{avatarError}}</p>
      </div>
      <template v-slot:modal-footer>
        <div class="w-100 button-group">
          <button
            class="btn btn-rounder btn-primary btn-contact "
            type="button" @click="hidePopupImage">保存</button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { BModal, VBModal } from 'bootstrap-vue'
export default {
  name: 'FileRename',
  props: {
    avatarError: {
      Type: String,
      Defaults: null
    }
  },
  components: {
    'b-modal': BModal
  },
  directives: {
    // Note that Vue automatically prefixes directive names with `v-`
    'b-modal': VBModal
  },
  data () {
    return {
      modalShow: false
    }
  },
  methods: {
    hidePopupImage () {
      this.$emit('hidePopupImage')
    }
  }
}
</script>
<style scoped lang="scss">
  @import "@/assets/stylesheet/auth/listfile.scss";
  .mr-30{
    margin-right: 30px;
  }
  .mw-253{
    max-width: 253px;
  }
</style>



// WEBPACK FOOTER //
// src/components/share/ErrorUploadImage.vue